import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

class PatientKioskUserLoginForm extends Component {
  componentDidMount() {
    const { handleLogin, location } = this.props;
    const queryString = location.search;
    const dataIndex = queryString.indexOf('&data=');
    const patientIdIndex = queryString.indexOf('ptId=');

    const singleSignOnId = queryString.substring(dataIndex + 6);
    const patientId = queryString.substring(patientIdIndex + 5, dataIndex);
    handleLogin(singleSignOnId, patientId);
  }

  render() {
    return (
      <div>
      </div>
    );
  }
}

PatientKioskUserLoginForm.propTypes = {
  handleLogin: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default connect()(PatientKioskUserLoginForm);
